import { useTranslation } from 'react-i18next';

import { Div } from "ui"

import OverlaySVG from './OverlaySVG'
import phoneIMG from 'assets/images/flixx/phone.png'
import { Text } from 'ui/index';


const TextCard2 = (props) => {

  const { t } = useTranslation()

  return (
    <Div position='relative'>
      <Div
        position='absolute'
        top='20%'
        left='50%'
        transform='translateX(-50%)'
        width='100%'
        maxWidth={345}
        minWidth={290}
      >
        <OverlaySVG height='100%' width='100%'/>

        <Div
          position='absolute'
          top='10.5%'
          left='5%'
          width='65%'
        >
          <Div>
            <Text color='headline' size='xs' weight='semibold'>
              {t('flixx_challenges_exampleTitle')}
            </Text>
          </Div>

          <Div marginTop={7} maxWidth={220}>
            <Text size='xs'>
              {t('flixx_challenges_exampleDescription')}
            </Text>
          </Div>
        </Div>


        <Div
          position='absolute'
          top='16%'
          left='76%'
        >
          <Div>
            <Text color='headline' size='xs'>
              {t('flixx_challenges_examplePrize')}
            </Text>
          </Div>
        </Div>


        <Div
          position='absolute'
          top='68%'
          left='50%'
          transform='translateX(-50%)'
          width='max-content'
        >
          <Div>
            <Text color='headline' size='sm' weight='medium' align='center'>
              {t('flixx_challenges_exampleCTA')}
            </Text>
          </Div>
        </Div>
      </Div>


      <Div
        maxWidth={345}
        margin='0 auto'
      >
        <img
          height='100%'
          width='100%'
          src={`${phoneIMG}`}
          alt=''
        />
      </Div>
    </Div>
  )
}

export default TextCard2
